<template>
<div>
  <highcharts class="chart" :options="options" ref="highchart" />
  <el-scrollbar class="status">
    <ul class="list list-event">
      <li v-for="point in legendPoints" :key="point.key" :class="getLegendClass(point.series)" :style="{borderColor: point.color}">
        <span class="number">{{ convertValuByUnit(point) }}</span>
        <span class="content" @click="onClickLegend(point.series)">
          <strong v-if="showObjName">{{ convertObjName(point.series) }}</strong>
          <span>{{ convertLegendName(point.series) }}</span>
        </span>
      </li>
    </ul>
  </el-scrollbar>
</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

import { isEmpty } from '@/utils/basic';
import { stackAreaOptions } from '@/constants/chart-options';
import { plotCharts } from '@/mixins/performance/charts';

export default {
  name: 'WPlotAreaChart',
  mixins: [plotCharts],
  props: {
    visible: {
      type: Boolean,
    },
    rscInfoList: {
      type: Array,
    },
    objInfo: {
      type: Object,
    },
    showObjName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: cloneDeep(stackAreaOptions),
    };
  },
  methods: {
    /**
     * 범례에 표현할 이름을 반환한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertLegendName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.options.rscInfo;
      if (!isEmpty(rscInfo)) {
        return isEmpty(rscInfo.rscKey) ? `${rscInfo.rscName}` : `${rscInfo.rscName} ${rscInfo.rscKeyName}`;
      }
      return series.name;
    },
    /**
     * 범례의 장비명을 표현한다.
     * @param  {[type]} series [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertObjName(series) {
      if (isEmpty(series)) {
        return null;
      }

      const rscInfo = series.userOptions.rscInfo;
      return isEmpty(rscInfo) ? null : rscInfo.objName;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/components/PlotAreaChart.vue